<div>
	<div class="compliance-outer">
		<h2 class="compliance-header text-center mb-4">
			Polymorphic Deployment
		</h2>
		<p class="ready-set-content text-center mb-5">
			One platform to deploy them all, one license to find them, one
			configuration to <br class="d-none d-md-block" />
			manage them all, and in the DevSecOps bind them.
		</p>
	</div>
	<div class="compliance-container">
		<div class="compliance-container-inner">
			<img
				class="d-none d-md-block orange-pattern-overlay"
				src="../../assets/img/orange-pattern.png"
				alt=""
			/>
			<img
				class="d-md-none orange-pattern-overlay"
				src="../../assets/img/orange-pattern-mobile.png"
				alt=""
			/>
			<div class="grid-wrapper text-center">
				<div class="row">
					<div class="col-md-3 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/autonomous.svg"
							alt=""
						/>
						<div class="challenges-list-head">Autonomous</div>
						<div class="challenges-list-content">
							Deploy on a single laptop or server with
							<br class="d-none d-md-block" />
							Docker—perfect for testing and
							<br class="d-none d-md-block" />
							evaluation.
						</div>
					</div>
					<div class="col-md-3 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/anywhere.svg"
							alt=""
						/>
						<div class="challenges-list-head">Anywhere</div>
						<div class="challenges-list-content">
							Use RegScale as a stand-alone service or
							<br class="d-none d-md-block" />
							with orchestration tools like Kubernetes, Docker
							<br class="d-none d-md-block" />
							Swarm, or any major cloud service like Azure,
							<br class="d-none d-md-block" />
							AWS, Google, or on classified/air-gapped
							<br class="d-none d-md-block" />
							networks.
						</div>
					</div>
					<div class="col-md-3 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/arrangeable.svg"
							alt=""
						/>
						<div class="challenges-list-head">Arrangeable</div>
						<div class="challenges-list-content">
							Use Infrastructure-as-Code to configure your
							<br class="d-none d-md-block" />
							deployment via YAML environment variables
							<br class="d-none d-md-block" />
							or leverage the admin panel in the User
							<br class="d-none d-md-block" />
							Interface to configure RegScale for your
							<br class="d-none d-md-block" />
							organization.
						</div>
					</div>

					<div class="col-md-3 mb-5 mb-lg-0">
						<img
							class="challenges-list-img"
							src="../../assets/img/adaptable.svg"
							alt=""
						/>
						<div class="challenges-list-head">Adaptable</div>
						<div class="challenges-list-content">
							Easily handle growth, load-balancing, fail-
							<br class="d-none d-md-block" />over, and
							non-disruptive upgrades with
							<br class="d-none d-md-block" />
							Kubernetes.
						</div>
					</div>
				</div>
				<a [routerLink]="['/pricing']">
					<button class="complaince-button py-2 px-5 mt-2 mt-lg-5">
						Get Started for Free
					</button></a
				>
			</div>
		</div>
	</div>
</div>
